import { Component } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';

import { ProjectDataActions } from '../../store/project-data/project-data.actions';
import { selectCanViewAndEditPrices, selectIsAdmin } from 'src/app/auth/store/session/session.selectors';
import { selectProjectEntityLoading, selectProjectEntityTree } from '../../store/project-data/project-data.selectors';
import { TreeEntity } from 'src/app/core/models/entity.model';
import { EntityTypeKey } from 'src/app/shared/constants/entity-type-keys';

@Component({
  selector: 'app-project-file-download',
  templateUrl: './project-file-download.component.html',
  styleUrls: ['./project-file-download.component.scss'],
  standalone: false
})
export class ProjectFileDownloadComponent {
  isAdmin$: Observable<boolean>;
  canAccessPrices$: Observable<boolean>;
  loading$: Observable<boolean>;
  projectEntity$: Observable<TreeEntity>;

  constructor(private store: Store) {
    this.isAdmin$ = this.store.select(selectIsAdmin);
    this.canAccessPrices$ = this.store.select(selectCanViewAndEditPrices);
    this.loading$ = this.store.select(selectProjectEntityLoading);
    this.projectEntity$ = this.store.select(selectProjectEntityTree);
  }

  exportToXml() {
    this.store.dispatch(ProjectDataActions.export_xml_start());
  }

  exportToMagiCAD() {
    this.store.dispatch(ProjectDataActions.export_magicad_start());
  }

  getReportProject(extension: 'pdf' | 'docx') {
    this.store.dispatch(ProjectDataActions.get_report_start({ reportType: 'Project', extension: extension }));
  }

  getReportQuotation(extension: 'pdf' | 'docx') {
    this.store.dispatch(ProjectDataActions.get_report_start({ reportType: 'Quotation', extension: extension }));
  }

  getReportDrawings(extension: 'pdf' | 'docx') {
    this.store.dispatch(ProjectDataActions.get_report_start({ reportType: 'Drawings', extension: extension }));
  }

  getReportBOM() {
    this.store.dispatch(ProjectDataActions.get_report_start({ reportType: 'BillOfMaterials', extension: 'xls' }));
  }

  getReportArticleNumbers() {
    this.store.dispatch(ProjectDataActions.get_report_start({ reportType: 'ArticleNumbers', extension: 'xls' }));
  }

  getDxf() {
    this.store.dispatch(ProjectDataActions.get_report_start({ reportType: 'Dxf', extension: 'dxf' }));
  }

  getAllDocuments() {
    this.store.dispatch(ProjectDataActions.export_alldocuments_start());
  }

  protected hasExportSelected(project: TreeEntity): boolean {
    return (
      project &&
      project.Children.some(x => x.EntityTypeKey === EntityTypeKey.GastroFlowHood && (x.Properties['IncludeInExports'].Value as boolean))
    );
  }
}
